import { Status } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const statusDictionary = createSimpleDictionary([
    { id: Status.Active, name: 'dictionaries.active' },
    { id: Status.Inactive, name: 'dictionaries.inactive' },
]);
